window.addEventListener("load", function(){
    $('table .template-select .preview').on('click', function(e){
        var el = $(this),
            input = el.next();
        el.toggleClass("selected");

        if(input.attr("disabled")){
            input.removeAttr("disabled");  
        } else {
            input.attr("disabled", "disabled");
        }

    });

    $('.block-pictures form').submit(function(e){
        var form = $(this),
            block = $(this).parent();
        $.post(
            form.attr('action'),
            form.serialize(),
            function(data){
                block.fadeOut("slow", function(e) {
                    block.remove();
                });
            }
        );
        return false;
    });

    $('ul.abuse-pictures .item .item-right .btn-abuse-submit').on('click', function(e){
        var link = $(this),
            block = $(this).parent().parent();
        $.post(
            link.attr('href'),
            function(data){
                block.fadeOut("slow", function(e) {
                    block.remove();
                });
            }
        );
        return false;
    });


    $(document).bind('reveal.facebox', function() {
    if($('#facebox .carousel').length > 0) {
        $('#facebox .popup .carousel .picture').css('height', 500);
        $('#facebox .popup .carousel .picture').css('width', 500); 
        resizeCarouselPicture();
    }
    });


    });

    $(window).load(function(){
    implementPictures();
    if($('.am-container').length > 0) {
        setTimeout(function() {
        $.get($('.am-container').attr('data-pictures'), function(data){
            $(data.pictures).each(function(){
                new Image().src = this;
            });
        });
        }, 1000);
    }
    });

    $(window).resize(function(){
    if($('#facebox .carousel').length > 0) {
    resizeCarouselPicture();
    }
    });

    function implementPictures() {
    if($('.show-mosaique').length > 0) {
        $('.show-mosaique').each(function(index) {
            var pictureBlock = $(this),
                pictureUrl = pictureBlock.attr('data-url'),
                pictureFilter = pictureBlock.attr('data-filter');
                pictureUser = pictureBlock.attr('data-user');
                countPicture = pictureBlock.attr('data-picture');
                pictureBlock.append('<div class="waiting"></div>');
            $.ajax({
                type: 'POST',
                url: pictureUrl,
                data: ({
                    filter: pictureFilter,
                    friendId : pictureUser
                }),
                success: function(data){
                    $('.show-mosaique .waiting').remove();
                    pictureBlock.find('.am-container').html(data);
                    var $container  = pictureBlock.children(),
                            imgs       = $container.find('img').hide(),
                            totalImgs   = imgs.length,
                            cnt         = 0;
                    imgs.each(function(i) {
                        var $img    = $(this);
                        $('<img/>').load(function() {
                            ++cnt;
                            if( cnt === totalImgs ) {
                                imgs.show();
                                if ($container.attr('id') == "mini-container") {
                                    if(countPicture && ((countPicture <= 3) || (countPicture > 5 && countPicture <= 8))) {
                                        $container.montage({
                                            fixedHeight : 75,
                                            minw : 75,
                                            fillLastRow: false
                                        });
                                    } else {
                                        $container.montage({
                                            fixedHeight : 75,
                                            minw : 75,
                                            fillLastRow: true
                                        });
                                    }

                                } else {
                                    $container.montage({
                                        fixedHeight : 100,
                                        minw : 100,
                                        margin : 2
                                    });
                                };
                            }
                        }).attr('src',$img.attr('src'));
                    });

                }
            });
        });
    }
}

function removeBackgroundPictures(pictureId) {
    $(".am-container a[id=" + pictureId + "]").remove();
}